<template>
    <RemoteTable ref="table" :form="form" :table="table">
        <template #default="{row, property}">
            <template v-if="property === 'code'">
                {{$root.getBusinessName(row.code)}}
            </template>
        </template>
    </RemoteTable>
</template>

<script>
    import RemoteTable from '@/components/RemoteTable'

    export default {
        components: {
            RemoteTable
        },
        data() {
            return {
                form: {
                    configs: [
                        {name: "code", label: "业务", type: "cascade", op: "beginwith", value: ""},
                        {name: "name", label: "名称", type: "input", op: "contains", value: ""},
                    ],
                    tools: [
                        {
                            icon: "el-icon-plus", click: () => {
                                this.$router.push("/autoreply/0")
                            }
                        }
                    ]
                },
                table: {
                    urlPrefix: "/autoreply",
                    columns: [
                        {label: "业务名称", name: "code"},
                        {label: "名称", name: "name", width: 200},
                        {label: "关键字", name: "keyword", width: 120},
                        {label: "回复内容", name: "content", width: 200},
                        {label: "创建时间", name: "createTime", width: 150},
                    ],
                    tools: []
                }
            }
        }
    }
</script>